import { contentApi } from '@/infrastructure/Configuration'

export default class ContentService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  async getCountries() {
    const url = `${contentApi}/countries`
    const response = await this.httpClient.get(url)
    return response.data.countries
  }

  async getStates(countryCode) {
    const url = `${contentApi}/rewards/countries/${countryCode}/states`
    const response = await this.httpClient.get(url)
    return response.data.states
  }

  async getLanguages() {
    const url = `${contentApi}/loyalty-languages`
    const response = await this.httpClient.get(url)
    return response.data.languages
  }

  async getInviteMember() {
    const url = `${contentApi}/rewards/invite-member`
    const response = await this.httpClient.get(url)
    return response.data
  }

  async getHotel(code) {
    const url = `${contentApi}/hotels/${code}`
    const response = await this.httpClient.get(url)
    return response.data.hotel
  }

  async getPremiumLine() {
    const url = `${contentApi}/rewards/premium-line`
    const response = await this.httpClient.get(url)

    return response.data
  }

  async getServiceLine(memberType = '') {
    const url = `${contentApi}/exclusive-line-by-type${memberType}`
    const response = await this.httpClient.get(url)

    return response.data
  }

  async transliteratableLanguages() {
    const url = `${contentApi}/transliteratable-languages`
    console.log('transliteratableLanguages', url)
    console.log(contentApi)
    const {
      data: { languages }
    } = await this.httpClient.get(url)

    return languages
  }

  async getAccountTutorialSteps() {
    const url = `${contentApi}/account/tutorial`
    const response = await this.httpClient.get(url)

    return response.data
  }

  async getProfileCompletion() {
    const url = `${contentApi}/account/profile-completion`
    const response = await this.httpClient.get(url)

    return response.data
  }

  async getCorporateAccountImage() {
    const url = `${contentApi}/account/corporate`
    const response = await this.httpClient.get(url)

    return response.data
  }

  async getCorporateInvite() {
    const url = `${contentApi}/rewards/corporate/share-invite`
    const { data } = await this.httpClient.get(url)
    return data
  }

  async getProfileCompletionModalInfo() {
    const url = `${contentApi}/catalog-profile/cards`
    const response = await this.httpClient.get(url)

    return response.data
  }

  async getMyAccountOfferParams() {
    const url = `${contentApi}/account/offer/sliders`
    const { data } = await this.httpClient.get(url)
    return data
  }

  async getNewsletterSubscriptionInfo() {
    const url = `${contentApi}/subscription/newsletter`
    const { data } = await this.httpClient.get(url)
    return data.subscriptionNewsLetter
  }

  async getPointsClaimInfo() {
    const url = `${contentApi}/rewards/points/claim`
    const { data } = await this.httpClient.get(url)
    return data.pointsClaimModule
  }
}
